import api from '../api';

export default {
  index({ search, page }) {
    return api.get(`/merchant/orders?search=${search}&page=${page}`);
  },
  store(data) {
    return api.post('/merchant/orders', data);
  },

  show(order) {
    return api.get(`/merchant/orders/${order}`);
  },

  refund(order, data) {
    return api.post(`/merchant/orders/${order}/refund`, data);
  },

  sendEmail(order) {
    return api.post(`/merchant/orders/${order}/send-email`);
  },
};
